import { cn } from '@algoacademy/design-system/shared/cn'
import { BadgeButton } from '../data-display/Badge'

type FilterBadgesProps<T extends string> = {
  options: Record<string, T>
  activeFilter: T
  onFilterChange: (filter: T) => void
  counts?: Record<T, number>
  className?: string
  highlightedBadges?: T[]
}

export function FilterBadges<T extends string>({
  options,
  activeFilter,
  onFilterChange,
  counts,
  highlightedBadges = [],
  className
}: FilterBadgesProps<T>) {
  return (
    <div className='flex flex-wrap gap-2'>
      {Object.entries(options).map(([key, value]) => {
        const isHighlighted = highlightedBadges.includes(value)

        return (
          <BadgeButton
            key={key}
            color={activeFilter === value ? 'darkBlue' : 'default'}
            onClick={() => onFilterChange(value)}
            className={cn(
              'gap-3 px-3 transition-colors',
              activeFilter !== value && isHighlighted && 'text-contentRed',
              className
            )}
          >
            {value}
            {counts && (
              <span
                className={cn(
                  'rounded-full px-1.5 py-0.5 text-xs',
                  activeFilter === value
                    ? 'bg-white/20'
                    : isHighlighted
                      ? 'bg-backgroundRed'
                      : 'bg-white/80 dark:bg-backgroundTertiary'
                )}
              >
                {counts[value]}
              </span>
            )}
          </BadgeButton>
        )
      })}
    </div>
  )
}
